import { useMemo } from 'react';

import { Button } from 'Components/Buttons/Buttons';
import { useCachedData } from 'Components/Context/CachedDataContext';
import { Modal } from 'Components/Modal/Modal';
import { ColumnConfig, ColumnType } from 'Components/Table/Columns';
import { Table } from 'Components/Table/Table';
import { ICON_CLOSE } from 'Config/Icons';
import { UserResponse } from 'Models/User';

export interface UsersModalProps {
    /** The modal header, describing which users are being displayed. For example, "Third-Party Service Delegates". */
    header: string;
    /** This function will be called when the modal's Close button is clicked. */
    hideModal: () => void;
    /** The IDs of the users that will be included in the table. */
    userIds: string[];
}

/** Displays users in a table with the columns Name, Email, and Department. */
export const UsersModal = (props: UsersModalProps) => {
    const cachedData = useCachedData();
    const users = useMemo(() => cachedData.users.filter((cachedUser) => props.userIds.includes(cachedUser.cognito_subject)), [cachedData.users, props.userIds]);

    const columns: ColumnConfig<UserResponse>[] = [
        {
            type: ColumnType.USER,
            name: 'Name',
            getUserId: (user) => user.cognito_subject,
            users: cachedData.users,
        },
        {
            type: ColumnType.STRING,
            name: 'Email',
            getString: (user) => user.email_address,
        },
        {
            type: ColumnType.STRING,
            name: 'Department',
            getString: (user) => user.department,
        },
    ];

    return (
        <Modal open header={props.header}>
            <Table<UserResponse> columns={columns} defaultSortColumn="Name" filters={[]} getUniqueIdForRow={(user) => user.cognito_subject} rowsData={users} />
            <div className={'modalFormButtonContainer'}>
                <Button variant="secondary" onClick={props.hideModal} fontAwesomeImage={ICON_CLOSE}>
                    Close
                </Button>
            </div>
        </Modal>
    );
};
